<div class="tm-scale"
     [class.tm-scale--bar]="scaleType === 'bar'"
     [class.tm-scale--line]="scaleType === 'line'"
     #scaleTarget></div>
